<template>
  <div>
    <router-link :to="{ name: 'property', params: { slug: link } }">
      <div class="card-carousel--card">
        <div class="card-carousel-card-image">
          <span class="card-carousel-process">
            {{
            property.process | parseProcess
            }}
          </span>
          <b-row class="card-carousel-price">
            <b-col class="price">{{ property.ownerPrice | formatPrice }}</b-col>
            <b-col class="reference">#Ref: {{ property.intReference }}</b-col>
          </b-row>
          <b-img
            v-if="!loadingMainMedia"
            :src="mainMedia"
            alt="Imagen principal de la propiedad"
            class="crop"
          />
          <template v-else>
            <b-spinner style="width: 3rem; height: 3rem; margin:90px;" label="Large Spinner"></b-spinner>
          </template>
        </div>
        <div class="card-carousel--card--footer">
          <b-col>
            <p class="address">
              <template v-if="property.houseType">
                {{
                property.houseType | parseHouse
                }}
              </template>
              <template v-else>
                {{
                property.propertyType | parseProperty
                }}
              </template>
              en {{ property.city }}, {{ property.zone }}
            </p>
          </b-col>
          <b-col class="card-characteristics-row">
            <span class="card-characteristic" v-if="property.bedrooms > 0">
              <span>{{ property.bedrooms }}</span>
              <i class="fa fa-bed"></i>
            </span>
            <span class="card-characteristic" v-if="property.toilet + property.washroom > 0">
              <span>{{ property.toilet + property.washroom }}</span>
              <i class="fa fa-bath"></i>
            </span>
            <span class="card-characteristic" v-if="property.area > 0 || property.usefulArea > 0">
              <i class="fa fa-arrows-alt"></i>
              <span v-if="property.area > 0">
                {{ property.area }}&nbsp;m
                <sup>2</sup>
              </span>
              <span v-else-if="property.usefulArea > 0">
                {{ property.usefulArea }}&nbsp;m
                <sup>2</sup>
              </span>
            </span>
          </b-col>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import MediaRepository from "@/repositories/MediaRepository";

export default {
  name: "Card",
  props: {
    item: Object,
    image: String,
    property: Object,
  },
  data() {
    return {
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 220,
      items: [],
      processTypes: [],
      mainMedia: "",
      loadingMainMedia: true,
      link: "",
    };
  },
  created() {
    this.getMainMedia();
    this.generateLink();
  },
  watch: {
    property: function () {
      this.getMainMedia();
      this.generateLink();
    },
  },
  methods: {
    generateLink() {
      if (this.property.city && this.property.zone) {
        const process = this.$options.filters
          .parseProcess(this.property.process)
          .toLowerCase()
          .replace(/ /g, "-");
        const property = this.property.houseType
          ? this.$options.filters
              .parseHouse(this.property.houseType)
              .toLowerCase()
              .replace(/ /g, "-")
          : this.$options.filters
              .parseProperty(this.property.propertyType)
              .toLowerCase()
              .replace(/ /g, "-");
        const city = this.property.city.toLowerCase().replace(/ /g, "-");
        const zone = this.property.zone.toLowerCase().replace(/ /g, "-");
        this.link =
          process +
          "-" +
          property +
          "-" +
          city +
          "-" +
          zone +
          "-" +
          this.property.intReference +
          "-" +
          this.property.processId;
      } else {
        this.link = this.property.intReference;
      }
    },
    async getMainMedia() {
      this.loadingMainMedia = true;
      const { data } = await MediaRepository.getMainMediaAsBase64ByRef(
        this.property.intReference
      );
      this.mainMedia =
        data && data.base64Img
          ? "data:" + data.type + ";base64, " + data.base64Img
          : MediaRepository.getDefaultImage();
      this.loadingMainMedia = false;
    },
  },
};
</script>

<style lang="scss">
$vue-navy: #2c3e50;
$vue-navy-light: #3a5169;
$vue-teal: #42b883;
$vue-teal-light: #42b983;
$gray: #666a73;
$light-gray: #f8f8f8;

.card-carousel--card {
  margin: 0 10px;
  cursor: pointer;
  box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06),
    0 2px 2px 0 rgba(40, 44, 53, 0.08);
  background-color: #fff;
  border-radius: 4px;
  z-index: 3;
  margin-bottom: 25px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  img {
    vertical-align: bottom;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    transition: opacity 150ms linear;
    user-select: none;

    &:hover {
      opacity: 0.5;
    }
  }

  &--footer {
    border-top: 0;
    padding: 7px 15px;

    p {
      padding: 3px 0;
      margin: 0;
      margin-bottom: 2px;
      font-size: 14px;
      font-weight: 500;
      color: $vue-navy;
      user-select: none;
      span {
        font-weight: 400;
      }

      &:nth-of-type(2) {
        font-size: 12px;
        font-weight: 300;
        padding: 6px;
        background: rgba(40, 44, 53, 0.06);
        display: inline-block;
        position: relative;
        margin-left: 4px;
        color: $gray;

        &:before {
          content: "";
          float: left;
          position: absolute;
          top: 0;
          left: -12px;
          width: 0;
          height: 0;
          border-color: transparent rgba(40, 44, 53, 0.06) transparent
            transparent;
          border-style: solid;
          border-width: 12px 12px 12px 0;
        }

        &:after {
          content: "";
          position: absolute;
          top: 10px;
          left: -1px;
          float: left;
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background: white;
          box-shadow: -0px -0px 0px #6e9360;
        }
      }
    }
  }
}
.card-carousel-card-image {
  position: relative;
  text-align: center;
  overflow: hidden;
  height: 230px;
}
.crop {
  position: absolute;
  left: -100%;
  right: -100%;
  top: -100%;
  bottom: -100%;
  margin: auto;
  min-height: 100%;
  min-width: 100%;
}
.card-carousel-process {
  position: absolute;
  padding-left: 6px;
  padding-right: 6px;
  right: 5px;
  top: 5px;
  font-size: 1em;
  color: #f8f8f8;
  background-color: #d86000;
  border-radius: 10px;
  z-index: 99;
}
.card-carousel-price {
  position: absolute;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 10px;
  left: 15px;
  right: 15px;
  bottom: 0;
  color: #f8f8f8;
  background-color: #6e9360c2;
  z-index: 99;
}
.card-carousel-price .price {
  font-size: 25px;
}
.card-carousel-price .reference {
  font-size: 15px;
  text-align: end;
  padding-top: 10px;
}

.card-property-icon {
  float: left;
  margin-top: -4px;
}
.card-characteristics-row {
  font-size: 13px;
  padding-top: 10px;
}
.card-characteristic {
  padding-right: 4px;
  color: #6e9360;
  span {
    font-weight: bold;
    margin-right: 4px;
  }
  i {
    margin-top: -4px;
  }
}
.address {
  font-size: 16px !important;
}

.card-carousel--card--footer {
  text-align: center;
}
</style>
